import { render, staticRenderFns } from "./AiMatchedList.vue?vue&type=template&id=6b8c56de&scoped=true&"
import script from "./AiMatchedList.vue?vue&type=script&lang=js&"
export * from "./AiMatchedList.vue?vue&type=script&lang=js&"
import style0 from "./AiMatchedList.vue?vue&type=style&index=0&id=6b8c56de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8c56de",
  null
  
)

export default component.exports